// extracted by mini-css-extract-plugin
export default {"box":"G69o3UFG6TZ046mkurH_"};